var InlineSpinner_module_default = {
	icon: "_icon_1855a_18",
	spin: "_spin_1855a_1"
};
//#endregion
export { InlineSpinner_module_default as default };

//# sourceMappingURL=InlineSpinner.module.js.map